'use client';

import { usePathname } from 'next/navigation';
import { createContext, ReactNode, useContext } from 'react';

const MetadataContext = createContext({
  dealId: '',
  isSharedReturnEnabled: false,
});

export const MetadataProvider = ({
  value,
  children,
}: {
  value?: { dealId: string; isSharedReturnEnabled: boolean };
  children: ReactNode;
}) => {
  const pathName = usePathname();

  const routes = pathName.split('/');
  const dealId = routes[routes.indexOf('mycars') + 1] ?? '';

  return (
    <MetadataContext.Provider
      value={value || { dealId, isSharedReturnEnabled: false }}
    >
      {children}
    </MetadataContext.Provider>
  );
};

export const useDealId = () => useContext(MetadataContext).dealId;
export const useIsSharedReturnEnabled = () =>
  useContext(MetadataContext).isSharedReturnEnabled;
